import { styled } from "styled-components";
import AmigoLogo from "../../assets/svg/amigosymbol.svg";
import { BACKGROUND, FONTSIZE, FONTWEIGHT } from "../../constants/theme";

export const HeaderStyled = styled.div`
    background: ${BACKGROUND.blue};
    padding-left: 50px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 96px;
    gap: 16px;
    box-sizing: border-box;
`;

HeaderStyled.Text = styled.p`
    margin: 0px;
    font-size: ${FONTSIZE.bigP};
    color: white;
    font-weight: ${FONTWEIGHT.normal};
`;

HeaderStyled.Icon = styled.img.attrs({
    src: AmigoLogo,
    alt: "Teste"
})`
`;

